import { newPermissions } from '@shared/newPermissions';

import {
  CounseledYouthPage,
  CounseledYouthPagePlaceholder,
} from './components';
import { COUNSELED_YOUTH_ROUTE } from './duck';

const routes = {
  [COUNSELED_YOUTH_ROUTE]: {
    path: '/counseledYouth',
    Component: CounseledYouthPage,
    Placeholder: CounseledYouthPagePlaceholder,
    titleId: 'page.counseledYouth',
    permission: newPermissions.VIEW_COUNSELED_YOUTH,
  },
};

export default routes;
